const PricingSection = () => {
  return (
    <section
      id="pricing"
      className="py-20 lg:py-32 bg-gradient-to-b from-orange-50 via-pink-50 to-white"
    >
      {/* soft top separator */}
      <div className="pointer-events-none absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-orange-300/40 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
          Simple & Transparent
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-pink-500">
            Pricing
          </span>
        </h2>
        <p className="text-xl text-slate-600 mb-16">
          Get started with flexible pricing that scales with your team.
        </p>

        <div className="max-w-lg mx-auto bg-white rounded-2xl shadow-xl p-10">
          <h3 className="text-2xl font-bold text-slate-900 mb-4">QuillStudio</h3>
          <p className="text-5xl font-extrabold text-slate-900 mb-6">
            $20 <span className="text-lg font-medium text-slate-600">/ user / month</span>
          </p>
          <ul className="text-slate-700 mb-8 space-y-3">
            <li>✔ Unlimited document generation</li>
            <li>✔ Salesforce native integration</li>
            <li>✔ Secure & scalable</li>
          </ul>
          <button className="px-6 py-3 rounded-xl bg-gradient-to-r from-orange-500 to-pink-500 text-white font-semibold shadow-lg hover:opacity-90 transition">
            Get Started
          </button>
        </div>

        <p className="mt-10 text-slate-600 text-lg">
          For <span className="font-semibold text-slate-900">100+ users</span>, connect with our Sales Team for custom pricing.
        </p>
      </div>
    </section>
  );
};

export default PricingSection;